'use strict';

import Swal from 'sweetalert2';

const formValidate = {
  init(event, fields, type = null) {
    let formError = false;

    formError = _this.loopFields(event.target, fields.common);

    if (type && !formError) {
      formError = _this.loopFields(event.target, fields[type]);
    }

    if (formError) {
      event.preventDefault();
      Swal.fire('Erro!', 'Preencha os campos obrigatórios', 'error');
    }
  },

  loopFields(form, fields) {
    let formError = false;

    for (let i = 0; i < fields.length; i++) {
      let field = fields[i];

      if (form[field] && !form[field].value) {
        formError = true;
        break;
      }
    }

    return formError;
  },

  validateMask(event, fields) {
    for (let type in fields) {
      if (type == 'cnpj') {
        if (!/^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/.test(fields[type].value)) {
          event.preventDefault();
          Swal.fire('Erro!', 'Preencha o CNPJ corretamente', 'error');
          break;
        }
      } else if (type == 'cep') {
        if (!/^[0-9]{5}-[0-9]{3}$/.test(fields[type].value)) {
          event.preventDefault();
          Swal.fire('Erro!', 'Preencha o CEP corretamente', 'error');
          break;
        }
      }
    }
  },
};

const _this = formValidate;

export default _this;
